/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function AIThinking({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" aria-hidden="true" viewBox="0 0 16 16" {...props}><path fillRule="evenodd" d="M4.886 3.794c-1.054.827-1.752 1.85-2.024 2.452-.287.634-.41 1.526-.322 2.375.09.872.384 1.515.737 1.809.427.354.79.44 1.307.44.256-.001.531-.023.877-.051l.133-.01c.399-.033.861-.066 1.393-.066 2.76 0 5.248 1.772 6.367 2.993a.753.753 0 0 1-.048 1.066.757.757 0 0 1-1.068-.047c-.96-1.049-3.073-2.503-5.251-2.503-.47 0-.883.03-1.272.06l-.133.01c-.336.028-.675.056-.995.056-.78.002-1.514-.155-2.276-.788-.796-.66-1.167-1.776-1.275-2.813-.11-1.06.03-2.23.449-3.153.371-.82 1.22-2.038 2.468-3.017C5.212 1.62 6.927.841 9 1.027a6.55 6.55 0 0 1 4.547 2.39C14.507 4.58 15 5.962 15 6.973c0 1.156-.294 2.206-.847 2.956-.564.767-1.436 1.248-2.454 1.053-.534-.103-.962-.418-1.286-.686a17 17 0 0 1-.405-.35 8 8 0 0 0-.544-.455c-.305-.229-.6-.386-.925-.451-.317-.063-.726-.05-1.28.163-1.244.48-2.374.394-3.006-.366-.618-.744-.448-1.788.213-2.412.29-.274.697-.54 1.035-.762l.07-.046c.393-.258.697-.464.881-.649.62-.618 1.964-1.345 3.375-.64.61.304 1.07.599 1.448.988.377.388.632.828.892 1.347a.756.756 0 0 1-1.352.675c-.24-.48-.412-.753-.625-.971-.21-.217-.501-.422-1.039-.69-.59-.295-1.248-.023-1.63.358-.315.315-.76.607-1.117.841L6.4 6.88c-.4.262-.706.463-.896.643-.173.163-.12.312-.088.351.018.022.306.306 1.299-.077.784-.303 1.485-.362 2.12-.236.627.125 1.129.42 1.535.723.243.181.507.414.725.606.109.096.206.182.284.246.293.243.471.339.606.365.318.06.648-.053.95-.464.315-.428.553-1.14.553-2.063 0-.599-.328-1.65-1.108-2.598A5.03 5.03 0 0 0 8.865 2.53c-1.593-.144-2.936.445-3.979 1.263" clipRule="evenodd" /></svg>;
}
;